import React from 'react'
import Page from '../templates/empower/wellbeing/spotlight/SpotLight-mental-health-and-wellbeing'

function spotlight() {
  return (
    <div>
      <Page/>
    </div>
  )
}

export default spotlight
